import { Guid } from '@web/utils';

export class AdminBoxCharacteristicDetails {
  public constructor(
    private readonly data: {
      id: Guid;
      label: string;
      content: string;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get label(): string {
    return this.data.label;
  }

  public get content(): string {
    return this.data.content;
  }
}
